// extracted by mini-css-extract-plugin
export var accordion = "PageTabs-module--accordion--4cf7c";
export var accordionWrapper = "PageTabs-module--accordionWrapper--bac47";
export var airportInfo = "PageTabs-module--airportInfo--c1c5b";
export var airportName = "PageTabs-module--airportName--a6e37";
export var alerts = "PageTabs-module--alerts--170ca";
export var categories = "PageTabs-module--categories--f96cc";
export var categoriesSection = "PageTabs-module--categoriesSection--29adc";
export var categoriesSectionTitle = "PageTabs-module--categoriesSectionTitle--b5877";
export var description = "PageTabs-module--description--b246f";
export var descriptionFull = "PageTabs-module--descriptionFull--0afae";
export var descriptionImages = "PageTabs-module--descriptionImages--9f38a";
export var detailsSection = "PageTabs-module--detailsSection--a3d19";
export var detailsSectionHeader = "PageTabs-module--detailsSectionHeader--32686";
export var diningCategoryTitle = "PageTabs-module--diningCategoryTitle--85524";
export var diningContainer = "PageTabs-module--diningContainer--38660";
export var diningTitle = "PageTabs-module--diningTitle--79d7e";
export var disclaimer = "PageTabs-module--disclaimer--2c0b2";
export var divider = "PageTabs-module--divider--77374";
export var facilitiesList = "PageTabs-module--facilitiesList--5c945";
export var facilitiesSection = "PageTabs-module--facilitiesSection--4e787";
export var featuresList = "PageTabs-module--featuresList--3ded1";
export var icon = "PageTabs-module--icon--113a8";
export var infoCardImage = "PageTabs-module--infoCardImage--c4362";
export var locationDescription = "PageTabs-module--locationDescription--2494c";
export var locationDetail = "PageTabs-module--locationDetail--6d3d9";
export var locationLabel = "PageTabs-module--locationLabel--8205c";
export var locationLink = "PageTabs-module--locationLink--e4db0";
export var modalContent = "PageTabs-module--modalContent--09422";
export var modalTitle = "PageTabs-module--modalTitle--1a99d";
export var resoprtMapModal = "PageTabs-module--resoprtMapModal--082ef";
export var scrollButton = "PageTabs-module--scrollButton--18d63";
export var title = "PageTabs-module--title--17d48";
export var trigger = "PageTabs-module--trigger--723ab";
export var triggerText = "PageTabs-module--triggerText--fb961";